const rankingItems = [
  { rank: 1, title: '某顶流被曝隐婚生子，工作室紧急回应', heat: '99万+', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '年度爆款剧大结局口碑崩塌，编剧道歉', heat: '87万+', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '网红主播带货翻车，退款金额超千万', heat: '76万+', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '选秀节目黑幕曝光，前选手实名举报', heat: '65万+', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '某情侣综艺嘉宾被曝假恋爱真炒作', heat: '58万+', tag: '新', tagColor: 'bg-secondary-500' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            吃瓜热度榜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时更新，全网瓜友都在关注的热门话题排行
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-background-50 transition-colors cursor-pointer rounded-xl`}
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-500 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                <span className="text-lg font-bold font-heading">{item.rank}</span>
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
              </div>

              <span className={`px-2.5 py-1 rounded-full text-xs font-medium text-white whitespace-nowrap ${item.tagColor}`}>
                {item.tag}
              </span>

              <div className="flex items-center gap-1 text-primary-500 flex-shrink-0">
                <i className="ri-fire-line text-sm"></i>
                <span className="text-sm font-semibold whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}